<template>
    <template v-if="!item.hideItem">
        <div v-if="!item.isSpacer" :class="containerClass" @touchstart.stop>
            <button v-if="!item.url || hasChildren" :class="contentClass" @mousedown.stop.left @click.stop.left="onClick"
                :aria-expanded="hasChildren ? isExpanded : null"
                :aria-controls="hasChildren ? `gmf-nav-child-${item.value}-${uid}` : null"
                :role="hasChildren ? 'button' : 'link'"
                :aria-current="isSelected ? 'page' : null"
            >
                <Icon v-if="showIcons" :icon="item.icon" />
                <div class="gmf-customer-card-navigation-text">{{ item.name }}</div>
                <Icon class="gmf-navigation-expand-icon" v-if="hasChildren"
                    :icon="isExpanded ? 'chevron_up' : 'chevron_down'" />
            </button>
            <a v-else-if="state.merchantId === 2183" :href="item.url" :class="contentClass"
                @mousedown.stop.left role="link" @click.stop>
                <Icon v-if="showIcons" :icon="item.icon" />
                <div class="gmf-customer-card-navigation-text">{{ item.name }}</div>
                <Icon class="gmf-navigation-expand-icon" v-if="hasChildren"
                    :icon="isExpanded ? 'chevron_up' : 'chevron_down'" />
            </a>
            <Link v-else :href="item.url" :class="contentClass" @mousedown.stop.left>
                <Icon v-if="showIcons" :icon="item.icon" />
                <div class="gmf-customer-card-navigation-text">{{ item.name }}</div>
                <Icon class="gmf-navigation-expand-icon" v-if="hasChildren"
                    :icon="isExpanded ? 'chevron_up' : 'chevron_down'" />
            </Link>
            <div v-if="hasChildren" v-show="isExpanded" :id="`gmf-nav-child-${item.value}-${uid}`"
                class="gmf-navigation-item-children">
                <SideNavItem
                    v-for="i in item.children"
                    :showIcons="showIcons"
                    :key="i.value"
                    :item="i"
                    :selectedItem="selectedItem"
                    :disableExpand="disableExpand"
                    @clickItem="clickItem" />
            </div>
        </div>
        <div v-else class="gmf-customer-card-navigation-spacer" @touchmove.prevent="() => { return true }"></div>
    </template>
</template>

<style>
.gmf-customer-card-navigation-item {
    user-select: none;
}

.gmf-navigation-item-content {
    width: 100% !important;
    display: flex;
    padding: var(--gmf-p-4);
    gap: var(--gmf-p-3);
    align-items: center;
    text-decoration: none;
    min-height: 45px;
    cursor: pointer;

    /* Reset button styles */
    background: none;
    border: none;
    text-align: left;
    margin: 0;
}

.gmf-navigation-item-content:hover, .gmf-navigation-item-content:focus {
    background: none;
}

.gmf-navigation-item-icon-less .gmf-navigation-item-content {
    padding-left: 30px;
}

.gmf-customer-card-navigation-item.gmf-active {
    /*background: var(--gmf-sidemenu-active-background-color);*/
    font-weight: bold;
    border-left: 4px solid var(--gmf-sidemenu-emphasis-background-color);   
}

.gmf-customer-card-navigation-item.gmf-active .gmf-icon {
    --gmf-icon-color: var(--gmf-sidemenu-active-text-color);
}

.gmf-customer-card-navigation-item .gmf-icon {
    width: 25px;
    height: 25px;
    flex-shrink: 0;
    --gmf-icon-color: var(--gmf-sidemenu-text-color);
}

.gmf-navigation-expand-icon {
    width: 15px !important;
    height: 15px !important;
}

.gmf-customer-card-navigation-item.gmf-customer-card-navigation-item-emphasis .gmf-icon {
    --gmf-icon-color: var(--gmf-sidemenu-emphasis-text-color);
}

.gmf-customer-card-navigation-item.gmf-customer-card-navigation-item-emphasis .gmf-customer-card-navigation-text {
    color: var(--gmf-sidemenu-emphasis-text-color);
}

.gmf-customer-card-navigation-item.gmf-customer-card-navigation-item-emphasis {
    margin-bottom: 2px;
    background: var(--gmf-sidemenu-emphasis-background-color);
}

.gmf-customer-card-navigation-item.gmf-customer-card-navigation-item-emphasis:last-child {
    margin-bottom: 8px;
}

.gmf-customer-card-navigation-spacer {
    flex: 1;
}

.gmf-context .gmf-customer-card-navigation-text {
    color: var(--gmf-sidemenu-text-color);
    white-space: nowrap;
}

.gmf-customer-card-navigation-item:has(.gmf-btn) {
    padding: var(--gmf-p-3) var(--gmf-p-4);
}
.gmf-customer-card-navigation-item .gmf-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: var(--gmf-p-3);
    margin: 0;
}
</style>

<script>
import Icon from '@/components/Icon';
import Link from '@/components/Link';
import state from '@/state';

let nextUid = 1;

export default {
    components: {
        Icon,
        Link,
    },
    name: 'SideNavItem',
    props: {
        item: {
            type: Object,
            required: true,
        },
        selectedItem: {
            type: Object,
            required: false,
        },
        disableExpand: {
            type: Boolean,
            required: false,
            default: false,
        },
        showIcons: {
            type: Boolean,
            required: false,
            default: true,
        }
    },
    emits: ['clickItem'],
    data() {
        return {
            isExpanded: false,
            state,
            uid: nextUid++,
        };
    },
    methods: {
        onClick(evt) {
            if (this.hasChildren && !this.disableExpand) {
                this.isExpanded = !this.isExpanded;
                if (this.isExpanded) {
                    this.$nextTick(() => {
                        //this.$el.scrollIntoView();
                    });
                }
                evt.stopPropagation();
                evt.preventDefault();
                return false;
            } else {
                this.clickItem(this.item, evt);
            }
        },
        clickItem(item, evt) {
            this.$emit('clickItem', item, evt);
        },
    },
    computed: {
        hasChildren() {
            return this.item.children && this.item.children.length > 0;
        },
        isSelected() {
            return this.selectedItem?.value == this.item.value;
        },
        containerClass() {
            return {
                'gmf-customer-card-navigation-item': true,
                'gmf-active': this.isSelected,
                //'gmf-customer-card-navigation-item-emphasis': this.item.isButton,

                'gmf-navigation-item-icon-less': !this.showIcons,
            };
        },
        contentClass() {
            return {
                'gmf-navigation-item-content': !this.item.isButton,
                'gmf-btn gmf-btn-primary': this.item.isButton,
            };
        },
    },
    watch: {
        disableExpand(v) {
            if (v) {
                this.isExpanded = false;
            }
        },
        selectedItem() {
            this.isExpanded = false;
        },
    },
};
</script>
